<template>
  <div class="p-1 dropstart">
        <div :style="skin.main_leagues.header" class="p-1 btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <span :class="'phoca-flag '+(language=='es'?'es':(language=='en'?'gb':'br'))" style="width:30px;height:20px;font-size:small"></span>
        </div>
        <ul class="dropdown-menu">
            <li v-for="(lang, index) in Object.keys(skin.languages)" :key="index"><button v-if="skin.languages[lang].enabled" class="dropdown-item" type="button" @click="change_language(lang)">{{ skin.languages[lang].name }}</button></li>
        </ul>
    </div>
</template>

<script>
export default {
    name:"language_selector",
    props:['skin','language'],
    data(){
        return {
            
        }
    },
    methods:{
        change_language(lg){
            this.$store.dispatch('setLanguage', lg);
        },
    }
}
</script>

<style>
</style>